module.exports = __webpack_public_path__ + "img/Yoga girl@2x.a47f8e5d.png";